module.exports = __webpack_public_path__ + "img/sHotSmash_193x205.1a5a64a2.png";